export default __webpack_public_path__ + "static/media/ebay.533bb88b.jpg";